import { render, staticRenderFns } from "./USP_VAL_REP_CUADRE_AT12_BA06_TIPOGARANTIAS.vue?vue&type=template&id=207667ed"
import script from "./USP_VAL_REP_CUADRE_AT12_BA06_TIPOGARANTIAS.vue?vue&type=script&lang=js"
export * from "./USP_VAL_REP_CUADRE_AT12_BA06_TIPOGARANTIAS.vue?vue&type=script&lang=js"
import style0 from "./USP_VAL_REP_CUADRE_AT12_BA06_TIPOGARANTIAS.vue?vue&type=style&index=0&id=207667ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports